import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
const SimpleImage = ({ image, className, eager }) => {
  const [load, setLoad] = useState(eager);
  useEffect(() => {
    setLoad(true);
  }, []);
  return (
    <img
      src={load ? image.url : null}
      alt={image.alt || ''}
      width={image.dimensions ? image.dimensions.width : null}
      height={image.dimensions ? image.dimensions.height : null}
      className={className}
    />
  );
};
SimpleImage.propTypes = {
  image: PropTypes.object.isRequired,
  className: PropTypes.string,
  eager: PropTypes.bool.isRequired
};
SimpleImage.defaultProps = {
  eager: false
};

export default SimpleImage;
